module.exports = "/build/web/svg/social/default/youtube.775710620860ba4878e709e5df7079ba.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/default/youtube.svg
// module id = 188
// module chunks = 24